import { Box, HStack, Icon, Pressable } from '@gluestack-ui/themed';
import React from 'react';
import { Icons } from '../../icons';
export const Card = ({ onPress, hideChevron = false, children, ...containerProps }) => {
    return (React.createElement(Pressable, { bg: "$gray200", p: "$3", rounded: "$lg", "$hover": {
            bg: onPress
                ? '$gray300'
                : containerProps?.bg || containerProps?.backgroundColor || '$gray200',
        }, shadow: 1, onPress: onPress, style: {
            // @ts-ignore - works for web, but RN doesn't like it
            cursor: onPress ? 'pointer' : 'default',
        }, ...containerProps },
        React.createElement(HStack, { flex: 1, w: "$full", alignItems: "center" },
            children,
            !!onPress && !hideChevron && (React.createElement(Box, { h: "$full", ml: "$2", justifyContent: "center" },
                React.createElement(Icon, { size: "xl", color: "$textNormal", as: Icons.ChevronRight }))))));
};
